import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { GlobalChatWidget } from '../../components/chat/GlobalChatWidget';

/**
 * ChatInterno — Página de Chat Institucional Unificada.
 * Integra-se diretamente ao motor de produção GlobalChatWidget em modo embedded (Full Canvas).
 * Suporta SSE em tempo real, envio de áudios/mídias/documentos, IA Copilot e catálogo hierárquico.
 */
export function ChatInterno() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const contatoId = searchParams.get('contatoId');

  useEffect(() => {
    document.title = 'Chat Institucional | Aluno Conectado';
  }, []);

  return (
    <div
      style={{
        height: '100%',
        minHeight: '100dvh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0b101b',
        padding: 0,
        margin: 0,
      }}
    >
      <GlobalChatWidget
        isOpen={true}
        onClose={() => navigate(-1)}
        isDocked={false}
        embedded={true}
        defaultContatoId={contatoId}
      />
    </div>
  );
}
